import styled from 'styled-components';

export const Page = styled.div``;

export const Header = styled.section`
  max-width: ${({ theme }) => theme.container};
  margin: 24px auto 0; padding: 0 16px;
`;

export const HeaderCard = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray[200]};
  border-radius: 12px; padding: 18px; margin-bottom: 16px;
  h1{ margin:0 0 6px; color: ${({ theme }) => theme.colors.green[700]}; }
`;

export const Section = styled.section`
  max-width: ${({ theme }) => theme.container};
  margin: 24px auto 0; padding: 0 16px;
`;

export const SectionTitle = styled.h2`
  color: ${({ theme }) => theme.colors.green[700]};
  margin: 0 0 16px;
  padding-bottom: 8px;
  border-bottom: 3px solid ${({ theme }) => theme.colors.orange[500]};
  display: inline-block;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: ${({ $executive }) => ($executive ? 'repeat(auto-fit, minmax(260px, 360px))' : 'repeat(auto-fit, minmax(220px, 1fr))')};
  gap: 16px;
  justify-content: ${({ $executive }) => ($executive ? 'center' : 'stretch')};
`;

export const Card = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray[200]};
  border-radius: 12px; overflow: hidden; text-align: center;
  width: ${({ $executive }) => ($executive ? '100%' : 'auto')};
  max-width: ${({ $executive }) => ($executive ? '360px' : 'none')};
  margin: ${({ $executive }) => ($executive ? '0 auto' : '0')};
  img{ width:100%; height: 220px; object-fit: contain; background: ${({ theme }) => theme.colors.gray[50]}; }
  h3{ margin: 10px 0 4px; color: ${({ theme }) => theme.colors.green[700]}; }
  h4{ margin: 0 0 8px; color: ${({ theme }) => theme.colors.orange[700]}; font-weight: 600; }
  p{ margin: 0 12px 16px; }
`;
